import { userInfoSync } from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
const PEER_SYNC_GATE = gate('chirp-fe:Pulse:PeerSync');
let __enabled;
export const __testOnlyDisablePeerSync = () => {
  __enabled = false;
};
export const __testOnlyEnablePeerSync = () => {
  __enabled = true;
};
export const __testOnlyResetPeerSync = () => {
  __enabled = undefined;
};
export const peerSyncEnabled = () => {
  if (__enabled === undefined) {
    try {
      __enabled = userInfoSync({
        ignoreRedirect: true
      }).gates.includes(PEER_SYNC_GATE);
    } catch (_unused) {
      __enabled = false;
    }
  }
  return __enabled;
};
const initResponseEvent = instanceKey => `pulse:peer-response:${instanceKey}`;
const dispatchInitResponse = (instanceKey, clientId, data) => window.dispatchEvent(new CustomEvent(initResponseEvent(instanceKey), {
  detail: {
    data,
    sourceId: clientId
  }
}));
const INIT_REQUEST_EVENT = 'pulse:peer-request';
const dispatchInitRequest = (instanceKey, clientId) => window.dispatchEvent(new CustomEvent(INIT_REQUEST_EVENT, {
  detail: {
    instanceKey,
    sourceId: clientId
  }
}));
const STATE_BATCH_EVENT = 'pulse:state-batch';
export const peerSyncManager = ({
  clientId,
  getState,
  applyBatch
}) => {
  const onInitRequest = event => {
    if (peerSyncEnabled() && event.detail.sourceId !== clientId) {
      const state = getState(event.detail.instanceKey);
      if ((state === null || state === void 0 ? void 0 : state.data) !== undefined && !state.loading && !state.error) {
        dispatchInitResponse(event.detail.instanceKey, clientId, state.data);
      }
    }
  };
  window.addEventListener(INIT_REQUEST_EVENT, onInitRequest);
  const onStateBatch = ({
    detail: {
      changes,
      sourceId
    }
  }) => {
    if (sourceId !== clientId) {
      applyBatch(changes);
    }
  };
  window.addEventListener(STATE_BATCH_EVENT, onStateBatch);
  let batch = [];
  return {
    pull: instanceKey => {
      if (!peerSyncEnabled()) {
        return undefined;
      }
      let result;
      const listener = ({
        detail: {
          data,
          sourceId
        }
      }) => {
        if (sourceId !== clientId && result === undefined) {
          result = data;
        }
      };
      const responseEventName = initResponseEvent(instanceKey);
      window.addEventListener(responseEventName, listener);
      dispatchInitRequest(instanceKey, clientId);
      window.removeEventListener(responseEventName, listener);
      return result;
    },
    collect: (instanceKey, data) => {
      if (peerSyncEnabled()) {
        batch.push({
          instanceKey,
          data
        });
      }
    },
    flush: () => {
      if (batch.length === 0) {
        return;
      }
      const changes = batch;
      batch = [];
      window.dispatchEvent(new CustomEvent(STATE_BATCH_EVENT, {
        detail: {
          changes,
          sourceId: clientId
        }
      }));
    },
    destroy: () => {
      window.removeEventListener(INIT_REQUEST_EVENT, onInitRequest);
      window.removeEventListener(STATE_BATCH_EVENT, onStateBatch);
      batch = [];
    }
  };
};